import { ApplicationInsights } from '@microsoft/applicationinsights-web'
import { pageModel } from './PageModel';

interface IConfig { 
    connectionString: string,
    appUserID: string,
    customerID: string
}

const config = pageModel<IConfig>('insights');

const appInsights = new ApplicationInsights({
    config: {
        connectionString: config.connectionString,
        extensionConfig: {
            ["AppInsightsCfgSyncPlugin"]: {
                cfgUrl: ""
            }
        }
    }
});
appInsights.loadAppInsights();
appInsights.clearAuthenticatedUserContext();
appInsights.setAuthenticatedUserContext(`${config.appUserID}`, `${config.customerID}`);
appInsights.trackPageView(); 

(<any>window).appInsights = appInsights;
